var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"lfs-filter-switch",attrs:{"label":_vm.label},on:{"change":_vm.handleInput},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})}
var staticRenderFns = []

export { render, staticRenderFns }